export default __webpack_public_path__ + "static/media/apple_b.03c04407.svg";